import { Banknote, Smartphone, Check } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { translations } from "@/i18n/translations";

export const PAYMENT_METHODS = [
  { id: "cash", label: "pay.cash", desc: "pay.cash_desc", icon: Banknote },
  { id: "juice", label: "pay.juice", desc: "pay.juice_desc", icon: Smartphone },
];

const tr = (key, vars) => {
  const lang = localStorage.getItem("padel-lang") || "en";
  let s = translations[lang]?.[key] ?? translations.en[key] ?? key;
  if (vars) Object.entries(vars).forEach(([k, v]) => { s = s.split(`{${k}}`).join(String(v)); });
  return s;
};

export const paymentLabel = (id) => tr(PAYMENT_METHODS.find(m => m.id === id)?.label || id);

export const waNumber = (n) => (n || "").replace(/[^0-9]/g, "");

export function proofWhatsAppUrl(club, item, kind = "court") {
  const amount = kind === "court" ? item.total_price : item.price;
  const what = kind === "court" ? tr("pay.proof_court", { date: item.date, time: item.start_time }) : tr("pay.proof_lesson", { coach: item.coach_name, date: item.date, time: item.start_time });
  const text = tr("pay.proof_text", { amount: Number(amount).toLocaleString(), what, ref: item.reference });
  const num = waNumber(club?.whatsapp) || "23057299188";
  return `https://wa.me/${num}?text=${encodeURIComponent(text)}`;
}

export default function PaymentMethodPicker({ value, onChange }) {
  const { t } = useLanguage();
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-2" data-testid="payment-method-picker">
      {PAYMENT_METHODS.map(m => {
        const active = value === m.id;
        return (
          <button
            key={m.id}
            type="button"
            onClick={() => onChange(m.id)}
            data-testid={`payment-method-${m.id}`}
            className={`flex items-start gap-3 p-3 rounded-xl border text-left transition-all ${
              active ? "border-coral bg-coral/10 ring-2 ring-coral/20" : "border-border/50 bg-muted/20 hover:bg-muted/40"
            }`}
          >
            <div className={`w-9 h-9 rounded-lg flex items-center justify-center shrink-0 ${active ? "bg-coral text-white" : "bg-muted text-muted-foreground"}`}>
              <m.icon size={16} />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-semibold flex items-center gap-1">{t(m.label)}{active && <Check size={12} className="text-coral" />}</p>
              <p className="text-[11px] text-muted-foreground leading-snug">{t(m.desc)}</p>
            </div>
          </button>
        );
      })}
    </div>
  );
}
